<template>
  <jc-dialog ref="createDialog"
             :buttons="buttons"
             :show.sync="show"
             column-class="col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1"
             title="Danh sách quyền"
             type="green"
             @onConfirm="$refs.form.submit()"
  >
    <div style="overflow: hidden">
      <b-row>
        <b-col>
          <c-table ref="table"
                   :data-filter="searchForm"
                   :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Mã quyền', sortField:'code', sortable: true},
                   {text: 'Người tạo', sortField:'createdBy', sortable: true},
                   {text: 'Thời gian tạo', sortField:'createdAt', sortable: true},
                   {text: 'Thao tác', width: '150px'},
               ]"
                   uri="/cms/api/v1.0/admin/permission/get-all"
          >
            <template #button>
              <c-form style="text-align: justify" @submit="$refs.table.reload()">
                <b-input-group style="margin-bottom: 0px">


                  <template v-if="isCreated">
                    <select2 v-model="createForm.actionId"
                             :data-ajax--delay="250"
                             :data-ajax--url="urlGetActionSelect2"
                             data-placeholder="Chọn hành động"
                    ></select2>
                  </template>

                  <template v-else>
                    <b-form-input v-model="searchForm.code" placeholder="Tìm kiếm theo mã quyền/mã hành động..."/>
                  </template>

                  <b-input-group-append>
                    <b-dropdown :split-variant="variant"
                                :variant="variant" right
                                split
                                @click="searchOrCreate()"
                    >
                      <template #button-content>
                        <template v-if="isCreated">
                          <i class="fas fa-plus-circle"></i>
                        </template>
                        <template v-else>
                          <i class="fas fa-search"></i>
                        </template>
                      </template>

                      <b-dropdown-item @click="isCreated = true"><i class="fas fa-plus-circle"></i> Thêm mới</b-dropdown-item>
                      <b-dropdown-item @click="isCreated = false"><i class="fas fa-search"></i> Tìm kiếm</b-dropdown-item>
                    </b-dropdown>
                  </b-input-group-append>
                </b-input-group>
              </c-form>
            </template>
            <template #default="{item, index}">
              <td class="text-right">{{ index }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.createdBy }}</td>
              <td>{{ item.createdAt | datetime }}</td>
              <td class="text-center">
                <b-button
                    class="btn btn-icon"
                    title="Xóa"
                    type="button"
                    variant="danger"
                    @click="deleteItem(item)"
                    v-has-permission="'permission_delete'"
                >
                  <i class="far fa-trash-alt"></i>
                </b-button>
              </td>
            </template>
          </c-table>
        </b-col>
      </b-row>

    </div>
  </jc-dialog>
</template>

<script>

import Select2 from "@/components/Forms/Select2";
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "ListActionDialog",
  mixins: [
    dialogMixins,
  ],
  components: {Select2},
  data: function () {
    return {
      buttons: {
        close: {
          text: 'Đóng',
          btnClass: 'btn-secondary btn-sm btn-simple',
        }
      },
      searchForm: {
        code: null
      },
      createForm: {
        actionId: null
      },
      resourceId: null,
      isCreated: false
    }
  },
  computed: {
    variant() {
      return this.isCreated ? 'success' : 'secondary';
    },
    urlGetActionSelect2() {
      return process.env.VUE_APP_API_URL + 'cms/api/v1.0/admin/actions/select2';
    },
  },
  methods: {
    open(item) {
      this.resourceId = item.id;
      this.show = true;
      this.searchForm = {
        code: null,
        resourceId: this.resourceId
      };
      this.createForm = {
        actionId: null
      };
    },
    searchOrCreate() {
      if (this.isCreated) {
        this.create();
      } else {
        this.search();
      }
    },
    search() {
      this.$refs.table.reload();
    },
    create() {
      this.$showLoader();

      this.$http.post('/cms/api/v1.0/admin/permission', {
        resourceId: this.resourceId,
        actionId: this.createForm.actionId
      }).then(res => {
        this.$stopLoader();
        this.$success();
        this.search();
        this.createForm.actionId = null;
      }, reason => {
        this.$stopLoader();
        this.errorNotify(reason);
      })
    },
    deleteItem(item) {
      this.$showLoader();

      this.$http
          .delete('/cms/api/v1.0/admin/permission/' + item.id)
          .then(res => {
            this.$stopLoader();
            this.$success();
            this.search();
          }, reason => {
            this.$stopLoader();
            this.errorNotify(reason)
                .then(reason => this.$cmsBadRequest(reason));
          });
    }
  }
}
</script>

<style>
</style>